import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/constants/routes';
import { callThunk, logoutAdmin, logoutUser } from '~/api';

const useHandleLogout = ({ isAdmin = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signinPage = isAdmin ? ROUTES.ADMIN.SIGNIN : ROUTES.USER.SIGNIN;
  const action = isAdmin ? logoutAdmin : logoutUser;

  const handleLogout = async (redirectUrl = signinPage) => {
    const res = await dispatch(
      callThunk({
        action,
      })
    );
    if (!res.error && res.payload === true) {
      // sessionStorageとlocalStorageのクリア
      sessionStorage.clear();
      localStorage.clear();
      navigate(redirectUrl);
    }
  };

  return handleLogout;
};

export default useHandleLogout;
